import { cva } from "class-variance-authority";

export { default as FeaturedIcon } from "./FeaturedIcon.vue";

export const sizes = ["xs", "sm", "md", "lg", "xl", "2xl"];
export const colors = ["brand", "gray", "error", "warning", "success"];
export const types = ["light", "dark", "modern"];
export const radius = ["full", "rounded"];

export const variants = cva(["flex", "items-center", "justify-center"], {
    variants: {
        size: {
            xs: ["w-6", "h-6"],
            sm: ["w-8", "h-8"],
            md: ["w-10", "h-10"],
            lg: ["w-12", "h-12"],
            xl: ["w-14", "h-14"],
            "2xl": ["w-18", "h-18"],
        },
    },
    compoundVariants: [
        {
            radius: "full",
            class: ["rounded-full"],
        },
        {
            radius: "rounded",
            size: "xs",
            class: ["rounded-sm"],
        },
        {
            radius: "rounded",
            size: "sm",
            class: ["rounded-sm"],
        },
        {
            radius: "rounded",
            size: "md",
            class: ["rounded-md"],
        },
        {
            radius: "rounded",
            size: "lg",
            class: ["rounded-lg"],
        },
        {
            radius: "rounded",
            size: "xl",
            class: ["rounded-lg"],
        },
        {
            radius: "rounded",
            size: "2xl",
            class: ["rounded-xl"],
        },
        {
            color: "brand",
            type: "light",
            class: ["bg-brand-secondary", "featured-icon-light-fg-brand"],
        },
        {
            color: "gray",
            type: "light",
            class: ["bg-tertiary", "featured-icon-light-fg-gray"],
        },
        {
            color: "error",
            type: "light",
            class: ["bg-error-secondary", "featured-icon-light-fg-error"],
        },
        {
            color: "warning",
            type: "light",
            class: ["bg-warning-secondary", "featured-icon-light-fg-warning"],
        },
        {
            color: "success",
            type: "light",
            class: ["bg-success-secondary", "featured-icon-light-fg-success"],
        },
        {
            color: "brand",
            type: "dark",
            class: ["bg-brand-solid", "featured-icon-dark-fg-brand"],
        },
        {
            color: "gray",
            type: "dark",
            class: ["bg-secondary-solid", "featured-icon-dark-fg-gray"],
        },
        {
            color: "error",
            type: "dark",
            class: ["bg-error-solid", "featured-icon-dark-fg-error"],
        },
        {
            color: "warning",
            type: "dark",
            class: ["bg-warning-solid", "featured-icon-dark-fg-warning"],
        },
        {
            color: "success",
            type: "dark",
            class: ["bg-success-solid", "featured-icon-dark-fg-success"],
        },

        {
            color: "brand",
            type: "modern",
            class: [
                "border-featured-icon-modern-border",
                "border",
                "bg-primary",
                "fg-brand-primary_alt",
            ],
        },
        {
            color: "gray",
            type: "modern",
            class: [
                "border-featured-icon-modern-border",
                "border",
                "bg-primary",
                "fg-secondary",
            ],
        },
        {
            color: "error",
            type: "modern",
            class: [
                "border-featured-icon-modern-border",
                "border",
                "bg-primary",
                "fg-error-secondary",
            ],
        },
        {
            color: "warning",
            type: "modern",
            class: [
                "border-featured-icon-modern-border",
                "border",
                "bg-primary",
                "fg-warning-secondary",
            ],
        },
        {
            color: "success",
            type: "modern",
            class: [
                "border-featured-icon-modern-border",
                "border",
                "bg-primary",
                "fg-success-secondary",
            ],
        },
    ],
});
